import React from "react";

import OurClients from "../components/home/OurClients.jsx";
import ProjectHighlight from "../components/home/ProjectHighlight.jsx";
import OurTechStack from "../components/home/OurTechStack.jsx";
import OurServices from "../components/home/Ourservices.jsx";
import Connect from "../components/Connect.jsx";
import Testimonial from "../components/home/Testimonial.jsx";
import LandingHero from "../components/home/LandingHero";

const Home = () => {
    return (
        <main className="main-wrapper">
            <LandingHero />
            <OurClients />
            <OurServices />
            {/* <ProjectHighlight /> */}
            <OurTechStack />
            {/* <Testimonial/> */}
            <Connect/>
        </main>
    );
};

export default Home;
